// styles.ts
import { makeStyles } from "@mui/styles";

interface Props {
  marginBottom?: string;
}

export const  useStyles = makeStyles(() => ({
  formControl: {
    width: "100%",
    marginBottom: (props: Props) => props.marginBottom || "20px",
  },
  dayContainer: {
    padding: "16px",
    marginBottom: "16px",
  },
  dayHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "8px",
  },
  timeRangeContainer: {
    display: "flex",
    alignItems: "center",
    marginBottom: "8px",
  },
  timeField: {
    marginRight: "16px",
  },
  timeDivider: {
    margin: "0 8px",
  },
  addButton: {
    marginTop: "8px",
  },
}));
